import { render } from "./BalavediList.vue?vue&type=template&id=64e74796&scoped=true"
import script from "./BalavediList.vue?vue&type=script&lang=js"
export * from "./BalavediList.vue?vue&type=script&lang=js"

import "./BalavediList.vue?vue&type=style&index=0&id=64e74796&scoped=true&lang=css"

import exportComponent from "C:\\Users\\shuha\\Documents\\Wisdom guide front\\wg-frontend-v1\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-64e74796"]])

export default __exports__